import { useMemo } from 'react';

import getExistingMembership from '@/app/[locale]/store/_utils/getExistingMembership';
import getExistingWarranty from '@/app/[locale]/store/_utils/getExistingWarranty';
import getMembershipSelection, {
  type GetMembershipSelection,
} from '@/app/[locale]/store/_utils/getMembershipSelection';
import getWarrantySelection, {
  type GetWarrantySelection,
} from '@/app/[locale]/store/_utils/getWarrantySelection';
import { useCartContext } from '@/app/contexts/CartProvider';

interface UseMultiRingSelectionsReturn {
  membershipSelection: GetMembershipSelection;
  warrantySelection: GetWarrantySelection;
}

const useMultiRingSelections = (): UseMultiRingSelectionsReturn => {
  const { refreshCart } = useCartContext();
  const cart = refreshCart?.cart;
  const lineItems = useMemo(() => cart?.lineItems ?? [], [cart]);

  // Memoize intermediate results
  const existingMembership = useMemo(
    () => getExistingMembership(lineItems),
    [lineItems],
  );
  const existingWarranty = useMemo(
    () => getExistingWarranty(lineItems),
    [lineItems],
  );

  // Memoize final selections
  const membershipSelection = useMemo(
    () => getMembershipSelection(existingMembership),
    [existingMembership],
  );
  const warrantySelection = useMemo(
    () => getWarrantySelection(existingWarranty),
    [existingWarranty],
  );

  return { membershipSelection, warrantySelection };
};

export default useMultiRingSelections;
